import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '~/components/ui/accordion';
import { AccordionInterface } from '~/payload-types';

import LexicalRenderer from '../LexicalRenderer';

type Props = AccordionInterface & {};

const AccordionBlock = (props: Props) => {
  const { elements } = props;
  if (elements == null) {
    return null;
  }
  return (
    <Accordion type="multiple" className="-mt-2 mb-2 border-t">
      {elements.map(async (element, index) => (
        <AccordionItem value={`item-${index}`} key={index}>
          <AccordionTrigger>{element.title}</AccordionTrigger>
          <AccordionContent>
            <LexicalRenderer data={element.content} />
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default AccordionBlock;
